import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * Tabs - используется для обработки переключений табов
 * основной аттрибут tab-id:
 * используется клик на тэге A, при отсутствуии href вызывается как Ajax.redirect, в противном случае меняет активность табса(m-active, selectedTabContent)
 * дополнительный аттрибут tab-view-settings:
 * используется на input[shouldrefreshtabs=true] по изменению элемента сериализует данные элемента и отправляет через Ajax.postJson
 */
export class TabsBehaviour extends BaseEmptyPrefixControlBehaviour {
    private tagViewSettings = 'tab-view-settings';

    constructor() {
        super('tabs');
    }

    protected getTabSwitches(element: any): JQuery {
        return $('a[tab-id]', element);
    }

    protected installBehaviour(element: HTMLElement): void {
        const tabs = this.getTabSwitches(element);
        tabs.unbind('click');
        tabs.on('click', (e) => this.handleTabClick(e));

        const refreshers = $(
            '.' + this.tagViewSettings + ' input[shouldrefreshtabs=true]',
            element
        );
        refreshers.change((e) => this.handleRefresherChange(e));
    }

    private handleTabClick(evt: JQueryEventObject) {
        evt.preventDefault();
        const tab = $(evt.currentTarget);

        const tabHref = tab.attr('href');
        if (tabHref == undefined || tabHref == '#') {
            const tabControl = tab.parents('[tabs]')[0];

            const tabHeaders = $('[tab-id]', tabControl).filter(
                (idx, el) => $(el).parents('[tabs]')[0] === tabControl
            );
            const tabSettingsContainer =
                '.' +
                this.tagViewSettings +
                '.tabs-' +
                $(tabControl).attr('id');

            $(tabSettingsContainer + ' input[name=m-active]').val(
                tab.attr(this.tag)
            );
            tabHeaders.removeClass('m-active');
            tab.addClass('m-active');

            const tabs = $('[tab-panelid]', tabControl).filter(
                (idx, el) => $(el).parents('[tabs]')[0] === tabControl
            );
            const tabContentShow = tabs.filter(
                '[tab-panelid=' + tab.attr('tab-id') + ']'
            );
            tabs.hide();
            tabs.removeClass('selectedTabContent');

            tabContentShow.show();
            tabContentShow.addClass('selectedTabContent');
        } else {
            Ajax.redirect(tabHref);
        }
    }

    private handleRefresherChange(evt: JQueryEventObject) {
        const settingsDiv = $(evt.target).parent(
            '.' + this.tagViewSettings + ''
        )[0];
        const settings = $('input', settingsDiv).serializeArray();
        const settingsObject: any = {};
        for (let i = 0; i < settings.length; i++) {
            const s = settings[i];
            settingsObject[s.name] = s.value;
        }

        if (
            settingsObject.tabsRefreshAjaxUrl &&
            settingsObject.tabsRefreshAjaxUrl !== ''
        ) {
            Ajax.postJson(settingsObject.tabsRefreshAjaxUrl, {
                data: settingsObject,
            });
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.TabsBehaviour = TabsBehaviour;